const MODAL_ACTIONS = {
    SIDEBAR_MODAL_OPEN: 'sidebar-modal:open',
    SIDEBAR_MODAL_CLOSE: 'sidebar-modal:close',
    RESERVATION_MODAL_CLOSE: 'reservation-modal:closed',
    RESERVATION_MODAL_OPEN: 'reservation-modal:open',
};

const MODAL_ACTION_CREATORS = {
    openSidebarModal() {
        return {type: MODAL_ACTIONS.SIDEBAR_MODAL_OPEN, isOpen: true};
    },
    closeSidebarModal() {
        return {type: MODAL_ACTIONS.SIDEBAR_MODAL_CLOSE, isOpen: false};
    },
    triggerModalOpenReservationChanges(changes) {
        return {type: MODAL_ACTIONS.RESERVATION_MODAL_OPEN, changes};
    },
    triggerCancelReservationChanges() {
        return {type: MODAL_ACTIONS.RESERVATION_MODAL_CLOSE, submit: false};
    },
    triggerSubmitReservationChanges() {
        return {type: MODAL_ACTIONS.RESERVATION_MODAL_CLOSE, submit: true};
    },
};

export default {MODAL_ACTIONS, MODAL_ACTION_CREATORS};
